import { render, staticRenderFns } from "./NotifContainer.vue?vue&type=template&id=f85b3536&scoped=true"
import script from "./NotifContainer.vue?vue&type=script&lang=js"
export * from "./NotifContainer.vue?vue&type=script&lang=js"
import style0 from "./NotifContainer.vue?vue&type=style&index=0&id=f85b3536&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f85b3536",
  null
  
)

export default component.exports